import React from "react";

export function RydToggleButton({
  active,
  onActivate,
  onDeactivate,
  activeStyle,
  inactiveStyle = {
    backgroundColor: 'lightgrey',
  },
  children
}: {
  active: boolean,
  onActivate: () => void,
  onDeactivate: () => void,
  activeStyle?: React.CSSProperties,
  inactiveStyle?: React.CSSProperties,
  children?: React.ReactNode
}) {
  return (
    <button
      onClick={active ? onDeactivate : onActivate}
      style={{
        ...(active ? activeStyle : inactiveStyle),
      }}
    >
      {children}
    </button>
  );
}